export function MessageQuestion({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.168 15.3568H10.8346L7.12629 17.8235C6.57629 18.1901 5.83464 17.7985 5.83464 17.1318V15.3568C3.33464 15.3568 1.66797 13.6902 1.66797 11.1902V6.1901C1.66797 3.6901 3.33464 2.02344 5.83464 2.02344H14.168C16.668 2.02344 18.3346 3.6901 18.3346 6.1901V11.1902C18.3346 13.6902 16.668 15.3568 14.168 15.3568Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0005 9.46484V9.28988C10.0005 8.72321 10.3505 8.4232 10.7005 8.18153C11.0422 7.9482 11.3838 7.64821 11.3838 7.09821C11.3838 6.33154 10.7672 5.71484 10.0005 5.71484C9.23383 5.71484 8.61719 6.33154 8.61719 7.09821"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99495 11.4596H10.0024"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
